module.exports = __webpack_public_path__ + "img/tit.da90cdee.png";